module.exports = __webpack_public_path__ + "static/img/Josh-Murphy.d01979a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Murphy.jpg
// module id = 2459
// module chunks = 0